import { useNavigate, useRoutes } from 'react-router-dom';
import Loader from './components/loader/loader';
import { CssBaseline, ThemeProvider } from '@mui/material';
import './assets/css/index.scss';
import Popup from './components/popup/popup'; 
import { Themefunc } from './theme/DefaultColors'; 
import { Routering } from './routes/routes';
// import { FirstTimeWebSrn } from './hooks/FirstTimeWebSrn/FirstTimeWebSrn';

function App() {
  const routing = useRoutes(Routering);
  const theme = Themefunc();
  const getToken=      localStorage.getItem("User_Data"); 
  const navigate = useNavigate();

  //  if(!getToken)
  //     navigate("/"); // Navigates to login page

  return (
    <ThemeProvider theme={theme}> 
      {/* <FirstTimeWebSrn /> */}
      <Popup />
      <Loader />
      <CssBaseline />
      {routing}
    </ThemeProvider>
  );
}

export default App;